import React, { useState } from "react";
import UniversityManagerLayout from "../../components/layout/UniversityManagerLayout";
import PermissionGuard from "../../components/common/PermissionGuard";
import { useUniAdminAuth } from "../../context/UniAdminAuthContext";
import { PERMISSIONS } from "../../utils/permissionKeys";
import UMGlobalFilterBar from "../../features/university-manager/analytics/UMGlobalFilterBar";
import UMAnalyticsDashboard from "../../features/university-manager/analytics/UMAnalyticsDashboard";
import UMAnalyticsEventsTable from "../../features/university-manager/analytics/UMAnalyticsEventsTable";
import { useTranslation } from "react-i18next";

const UMAnalytics = () => {
  const { can } = useUniAdminAuth();
  const { t } = useTranslation(["universityManager"]);

  const [filters, setFilters] = useState({
    clubId: "",
    categoryId: "",
    startDate: "",
    endDate: "",
  });

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  return (
    <UniversityManagerLayout>
      <PermissionGuard allow={can(PERMISSIONS.analytics.view)}>
        <div className="analytics-page">
          <div className="mb-4">
            <h1 className="h3 mb-1 fw-bold text-dark">{t("analytics.title")}</h1>
            <p className="text-muted mb-0">{t("analytics.subtitle")}</p>
          </div>

          <UMGlobalFilterBar filters={filters} onFilterChange={handleFilterChange} />
          
          <UMAnalyticsDashboard filters={filters} />

          {can(PERMISSIONS.analytics.events) && (
            <UMAnalyticsEventsTable filters={filters} />
          )}
        </div>
      </PermissionGuard>
    </UniversityManagerLayout>
  );
};

export default UMAnalytics;
